import AudioSetupButton from './button';
import AudioSetupModal from './modal';

export { AudioSetupButton, AudioSetupModal };

export const hasCompletedAudioSetup = () => {
  return !!localStorage.getItem('audioSetupFinished');
};
